import T from '../../../../i18n/Text';
import { Link } from "react-router-dom";
import { Game } from '../../../../types';
import GameOptionsIconList from '../../../GameOptionsIconList';
import React from "react";
import "./SimilarGameItem.css"

interface Props {
    game: Game;
}

const SimilarGameItem = ({ game }: Props) => {

    return (
        <div className="similar-game-item w-[320px] sm:w-[400px] flex-none flex-col">
            <div className="image-container w-full aspect-square">
                <img className='w-[320px] h-[320px] sm:w-[400px] sm:h-[400px]' src={`/images/games/${game.name}.png`} alt={game.name} />
                <Link to={`/games/${game.name}`} className="play-btn flex justify-center items-center text-white bg-[#252429] border-none hover:bg-[#198754] w-full md:w-[210px] h-[54px] rounded-[3px] text-[20px] leading-6 font-semibold disabled:bg-[#B6B6B6] disabled:border-none transition-colors ease-in-out duration-200">
                    <T path="games.buttons.play" />
                </Link>
            </div>
            <div className="flex flex-col justify-between items-center w-full pt-[23px] px-[10px] gap-[10px]">
                <h3 className="text-[28px] leading-[34px] font-medium text-center">
                    <Link to={`/games/${game.name}`}><T path={`games.${game.name}.name`} /></Link>
                </h3>
                <div className="w-fit mx-auto">
                    <GameOptionsIconList game={game} />
                </div>
            </div>
            <Link to={`/games/${game.name}`} className="bottom-play-btn flex justify-center items-center text-white bg-[#252429] border-none hover:bg-[#198754] w-full md:w-[210px] h-[54px] rounded-[3px] text-[20px] leading-6 font-semibold disabled:bg-[#B6B6B6] disabled:border-none transition-colors ease-in-out duration-200">
                <T path="games.buttons.play" />
            </Link>
        </div>
    )
};

export default SimilarGameItem;
